import React, { useEffect, useState } from 'react';
import PrintDashboardTemplate from '../PrintDashboardTemplate';
import Table from '../Table/Table';
import { useHistory } from 'react-router';
import styles from './PrintHome.module.css';
import RenderByPermission from 'components/RenderByPermission';
import { getMe } from 'services/auth';
import { toast } from 'react-toastify';
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  root: {
    // flexGrow: 1,
  },
  isTrialCont: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    backgroundColor: "#FEFFFA",
    border: "1px solid #A5C62E",
    padding: "2%",
    borderRadius: "10px",
    marginTop: "2%",
    marginLeft: "7%",
    marginRight: "7%",
  },
  isBillingCont: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    backgroundColor: "#F9FDFF",
    border: "1px solid #5ED0FA",
    padding: "2%",
    borderRadius: "10px",
    marginTop: "2%",
  },
  heading: {
    fontWeight: "bold",
    fontSize: "16px",
    color: "#A5C62E",
    marginBottom: "0",
  },
  headingBilling: {
    fontWeight: "bold",
    fontSize: "16px",
    color: "#5ED0FA",
    marginBottom: "0",
  },
  btn: {
    border: "1px solid #A5C62E",
    color: "#A5C62E",
    padding: "10px 25px",
    borderRadius: "5px",
    fontWeight: "bold",
    fontSize: "16px",
    backgroundColor: "#FFFBF1",
  },
  btnBilling: {
    border: "1px solid #5ED0FA",
    color: "#5ED0FA",
    padding: "10px 25px",
    borderRadius: "5px",
    fontWeight: "bold",
    fontSize: "16px",
    backgroundColor: "#F9FDFF",
  },
  timerTime: {
    fontWeight: "800",
    fontSize: "20px",
    color: "#F2B11B",
    backgroundColor: "#FFF8E9",
    padding: "10px 15px",
    borderRadius: "10px",
  },
  timeCont: {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    justifyContent: "space-evenly",
  },
  indct: {
    fontSize: "12px",
    color: "#010E20",
  },
  descInfo: {
    border: "1px solid #E5E5E5",
    backgroundColor: "#FBFCFC",
    marginTop: "2%",
    padding: "3%",
    borderRadius: "10px",
    textAlign: "left",
  },
}));

const defaultPaginationState = { page: 0, per_page: 5 };

const PrintHome = () => {
  const classes = useStyles();
  const history = useHistory();
  const [paginationData, setpaginationData] = React.useState(defaultPaginationState);
  const [templateCategory, setTemplateCategory] = React.useState('active');
  const [userData, setUserData] = useState("");

  function handlecategoryChange(e) {
    setTemplateCategory(() => {
      setpaginationData(defaultPaginationState);
      return e.target.value;
    });
  }

  function getProfile() {
    getMe()
      .then((me) => {
        setUserData(me.data);
      })
      .catch((e) => {
        toast.notify("An error occurred, try refreshing this page", {
          type: "error",
        });
      });
  }

  const handleClick = () => {
    history.push({
      pathname: "/print-pricing",
    });
  };

  useEffect(() => {
    getProfile();
  }, []);

  return (
    <RenderByPermission>
      <PrintDashboardTemplate>
        <div className={styles.container}>
          <div className={styles.top_bar}>
            <h1>Dashboard</h1>
            <button onClick={() => history.push('/create-template')}>
              <i className='fas fa-plus'></i>
              New Template
            </button>
          </div>
        </div>
        <div
          style={{
            width: "100%"
          }}
        >
          {userData.print_free_trial === true && userData.print_active_plan === null ? (
            <div className={classes.isTrialCont}>
              <div>
                <p className={classes.heading}>
                  You are currently on a 15-day trial plan
                </p>
                <p style={{ marginBottom: "0" }}>
                  Upgrade now for uninterrupted
                  access to our premium features
                </p>
              </div>

              <div>
                <button onClick={handleClick} className={classes.btn}>
                  Upgrade
                </button>
              </div>
            </div>
          ) : null}

          {/* {billingProceed && (
            <div className={classes.isBillingCont}>
              <div>
                <p className={classes.headingBilling}>Activate Billing</p>
                <p style={{ marginBottom: "0" }}>
                  You currently do not have an active plan on your account. click
                  the button to set up a plan
                </p>
              </div>

              <div>
                <button onClick={handleClick} className={classes.btnBilling}>
                  Upgrade
                </button>
              </div>
            </div>
          )} */}
        </div>
        <div className={styles.table_container}>
          <div className={styles.select_template_category}>
            <select name={templateCategory} value={templateCategory} onChange={handlecategoryChange}>
              <option value='active'>Active Templates</option>
              <option value='archived'>Archived Templates</option>
            </select>
          </div>
          <Table {...{ paginationData, setpaginationData, templateCategory }} />
        </div>
      </PrintDashboardTemplate>
    </RenderByPermission>
  );
};

export default PrintHome;
